import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_177_21)">
      <path
        d="M6.25403 4.02542C8.28089 4.02542 9.97235 6.57639 10 8.84334C10 9.02396 9.86415 9.075 9.73552 8.84334C9.08154 7.57112 8.01161 6.91146 6.60867 6.91146H6.29491V8.42188C6.29491 8.87344 5.81644 9.18233 5.46902 8.87868L2.26162 6.0764C1.91299 5.77275 1.91299 5.27538 2.26042 4.97172L5.49186 2.14066C5.83928 1.83569 6.24682 2.04642 6.24682 2.58174L6.25403 4.02542Z"
        fill="white"
        style={{ fill: "white", fillOpacity: 1 }}
      />
    </g>
    <defs>
      <filter
        id="filter0_d_177_21"
        x="-4"
        y="-4"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.136354 0 0 0 0 0.683754 0 0 0 0 0.991667 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_177_21"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_177_21"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgComponent;
